import { useQuery } from "@tanstack/react-query";
import { keywordVolumeService } from "@/services/KeywordVolumeService";

export const getKeywordVolumesWithDomainsQueryKey = (page: number, limit: number, search = "") =>
  ["keywordVolumesWithDomains", page, limit, search] as const;

interface UseKeywordVolumesWithDomainsParams {
  page: number;
  limit: number;
  search?: string;
}

export const useKeywordVolumesWithDomains = ({
  page,
  limit,
  search = "",
}: UseKeywordVolumesWithDomainsParams) =>
  useQuery({
    queryKey: getKeywordVolumesWithDomainsQueryKey(page, limit, search),
    queryFn: () => keywordVolumeService.getLatest(page, limit, search),
    staleTime: 1000 * 60 * 5,
  });
